import React, { useEffect, useState } from 'react'
import Select from "react-select";
import {
  enviarReporteDeCampaniaAPI
} from '../../consumers/backendApisUrls';
import {
    cuadroRequerimientosGetCampanasForFiltroListarCuadroSedesAPI,    
} from '../../consumers/backendApisUrls';
import { useSubmitForm } from '../../hooks/useSubmitForm/useSubmitForm';
import {useManageGetRequest} from "../../hooks/useManageGetRequest/useManageGetRequest";
import {
    isNullOrUndefinded    
} from "../../helper/utils";
import useDidMountEffect from "../../hooks/useDidMountEffect/useDidMountEffect";

const ReporteCuadroRequerimientosCampania = () => {

    const SECTION_NAME = "ReporteCampaña";
    const KEYS = {
        IdCampania: "IdCampania",        
    };

    const [allCampanas, setallCampanas] = useState([]);
    const [selectedCampana, setSelectedCampana] = useState();
    const [isDownloading, setIsDownloading] = useState(false);    

    const [executeManageGet] = useManageGetRequest();    
    const [submitForm] = useSubmitForm();    

    const init = async () => {
        setIsDownloading(true);
        try {            
            await getAllCampanas();            
            // if (formValues.filters.length === 0) {
            //     jsonNoEstaVacio(formValues.ExtraData) &&
            //     updateFiltersWithExtraData(allFilters, formValues.ExtraData, handleUpdatedFilters);
            // }
            setIsDownloading(false);
        } catch (error) {
            console.error(error);
        } finally {
            setIsDownloading(false);
        }
    }

    const getAllCampanas = async () => {
        const api = cuadroRequerimientosGetCampanasForFiltroListarCuadroSedesAPI();
        await executeManageGet(api, (res) => successGetAllCampanasCallback(res), false);
    }

    const successGetAllCampanasCallback = ({data}) => {
        const items = data.map(o => ({value: o.IdCampana, label: o.Nombre}));
        setallCampanas(items);

        if (items.length > 0) {
            if (isNullOrUndefinded(selectedCampana?.value)) {
                setSelectedCampana(items[0]);
            }else{
                let selected = items.find(o => o.value === selectedCampana?.value);
                setSelectedCampana(selected);
            }
        }
    }

    const handleSendReport = async () => {
        setIsDownloading(true);
        const api = enviarReporteDeCampaniaAPI();
        const payload = getPayload();
        try {
          await submitForm(Object.values(KEYS), api, payload, SECTION_NAME, () => {});
        } catch (error) {
          console.error(error);
        } finally {
          setIsDownloading(false);
        }
    }

    const getPayload = () => {
        return {
            IdCampana: selectedCampana?.value
        };
    }    

    useEffect(() => {
        init();
    }, [])

    useDidMountEffect(() => {
    }, [selectedCampana?.value])

    return (        
        <div className='card-body'>
            <div id={SECTION_NAME}>
                <div className="col-sm-5"> 

                    <SelectCampanas items={allCampanas} selectedItem={selectedCampana} setSelectedItem={setSelectedCampana}/>
                </div>        
        
                <div className='col-sm-5'>
                    <button 
                    className="btn btn-primary generic-button-ficha mt-2" 
                    onClick={handleSendReport} 
                    disabled={isDownloading}>
                    {isDownloading ? 'Enviando Reporte ...' : 'Enviar via Gmail'}
                    </button>
                </div>
            </div>
        </div>
    )
}

export default ReporteCuadroRequerimientosCampania;

const SelectCampanas = ({items, selectedItem, setSelectedItem}) => (
    
    <Select
        label="Selecciona una campaña"
        placeholder="Seleccionar Campaña"
        options={items}
        value={selectedItem}
        onChange={(res) => setSelectedItem({...res})}
    />    
)